import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { MatLegacyTabChangeEvent as MatTabChangeEvent } from '@angular/material/legacy-tabs';
import { CustomEvents, DATE_TIME_FORMAT_DDMMYYYY } from '@app/_helpers';
import { ConfigurationService, EventsService } from '@app/_shared';
import { ProfileMenuComponent } from '@app/_shared/modules/profile-menu/profile-menu.component';
import { AuthService } from '@app/modules/auth';
import { Subscription } from 'rxjs';
import { NotificaionMsgType } from '../../../../../../../utProto/webEnums_pb';
import { MbPlansService } from '../../../mb-plans/providers/mb-plans.service';
import { NotificationsService } from '../../providers/notifications/notifications.service';
import { NotificationTabs, NotificationType } from './notifications.consts';


@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss']
})
export class NotificationsComponent implements OnInit, OnDestroy {

  DATE_TIME_FORMAT = DATE_TIME_FORMAT_DDMMYYYY;
  matDialogRef: MatDialogRef<ProfileMenuComponent>;
  selectedTab = 0;
  notificationType = NotificationType;
  tradesCount: number = 0;
  backtestCount: number = 0;
  offersCount: number = 0;
  viewLoader: boolean = false;
  notificationTabs = NotificationTabs;
  // showPlanExtendedOffer: boolean = false;
  // free_plan_extension_days: number = 7;
  private subscriptions = new Subscription();

  showDiyUpdateNotification = false;

  isBacktestAllowed: boolean;

  constructor(
    public notificationsService: NotificationsService,
    private matDialog: MatDialog,
    private configurationService: ConfigurationService,
    private mbPlansService: MbPlansService,
    private authService: AuthService,
    private events: EventsService,
  ) {
    this.tradesCount = this.getTabCount(NotificationType.Trades);
    this.backtestCount = this.getTabCount(NotificationType.Backtest);

    this.subscriptions.add(
      this.notificationsService.notificationUpdate.subscribe(() => {
        this.tradesCount = this.getTabCount(NotificationType.Trades);
        this.backtestCount = this.getTabCount(NotificationType.Backtest);
      })
    );

    this.subscriptions.add(
      this.notificationsService.viewLoader.subscribe((displayViewLoaderBool: boolean) => {
        this.viewLoader = displayViewLoaderBool;
      })
    );

    // added some conditions to remove redundant planInfo calls
    // if (this.authService.isAuthenticated && !this.authService.isAdminLogin) {
    //   this.subscriptions.add(
    //     this.mbPlansService.getCurrentPlan(false).subscribe((res) => {
    //       if (!res.is_connected_to_broker_before) {
    //         this.showPlanExtendedOffer = true;
    //         this.calculateOffersCount();
    //       }
    //       this.free_plan_extension_days = res.free_plan_extension_days;
    //     })
    //   )
    // }

    this.subscriptions.add(
      this.notificationsService.fetchPersistantNotifications().subscribe(res => {
        if (res && res.length) {
          const notification = res.find(noti => noti?.responseMap.messageType === NotificaionMsgType.NOTIFICAIONMSGTYPE_NEWPLANADDED);
          if (notification) {
            this.calculateOffersCount();
            this.showDiyUpdateNotification = true;
          }
        }
      })
    );

    this.subscriptions.add(
      this.events.subscribe(CustomEvents.DIYUpdateAcknowledged, (show: boolean) => {
        this.showDiyUpdateNotification = show;
        this.calculateOffersCount();
      })
    );

    this.isBacktestAllowed = this.configurationService.remoteConfigCacheObj?.ORIGINALS_BT;
  }

  ngOnInit(): void {
  }

  calculateOffersCount() {
    this.offersCount = 0;
    // this.showPlanExtendedOffer && this.offersCount++;
    this.showDiyUpdateNotification && this.offersCount++;
  }

  toggleNotificationSidenav() {
    this.notificationsService.toggleNotificationSidenav();
  }

  onMatTabChange(event: MatTabChangeEvent) {
    this.markAllAsRead(NotificationTabs[this.selectedTab]);
    this.selectedTab = event.index;
    this.notificationsService.selectedTab = NotificationTabs[this.selectedTab];
  }

  getTabCount(type: string) {
    return this.notificationsService.getUnreadMessages(type);
  }

  markAllAsRead(type: string) {
    this.notificationsService.markAllAsRead(type);
  }

  openProfileCard() {
    this.notificationsService.toggleNotificationSidenav();

    this.matDialogRef = this.matDialog.open(ProfileMenuComponent, {
      width: '250px',
      position: {
        top: '48px',
        right: '40px'
      },
      panelClass: 'profile-panel',
    });
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

}
